import {EChannelType} from 'src/constants';
import {ELicensePeriod} from 'src/containers/Licenses/definitions';
import {
  ELicenseLabelType,
  TTariffChannelType,
  TTariffDetail,
  TTariffPricingDetail,
} from 'src/containers/TariffsCatalog';
import {EDocumentType} from 'src/containers/User';

type TAvailableTariff = {
  id: number;
  tariffCatalogId: number;
  channelType: TTariffChannelType;
  tenantId: number;
  name: string;
  licenseDetailId: number;
  data: Partial<Record<ELicenseLabelType, number>>;
  activeFrom: string | Date;
  activeTo: string;
  version: number;
  planned: boolean;
  active: boolean;
  visible?: boolean;
  isSmsCommon?: boolean;
};

type TAvailableTariffResponse = {active: TAvailableTariff; planned?: TAvailableTariff};

type TConnectedTariff = {
  id: number;
  version: number;
  subjectId: number;
  selectedTariffId: number;
  activeFrom: string;
  activeTo?: string;
  planned: boolean;
  active: boolean;
};

type TConnectedTariffResponse = {active: TConnectedTariff; planned?: TConnectedTariff};

type TCreateAvailableTariffFormData = {
  tenantId?: number;
  tariffCatalogId: number;
  name?: string;
  channelType: EChannelType;
  licensePeriod: ELicensePeriod;
  licenseDetailId: number;
  license: number;
  connectionFee?: number;
  amau?: number;
  licensePrice?: number;
  connectionFeePrice?: number;
  amauPrice?: number;
};

type TTariffDetailFinalPrice = {
  currency: TTariffDetail['currency'];
  country: TTariffDetail['country'];
  data?: TTariffDetail['data'];
  prices: {
    label: TTariffPricingDetail['label'];
    price: number;
  }[];
};

type TTariffsLicensesFilters = {
  channelType: EChannelType;
  licensePeriod: ELicensePeriod;
  resellerId?: number;
  currency?: string;
  documentType?: EDocumentType | null;
};

const DETAIL_PERIOD_MONTHS = {
  [ELicensePeriod.MONTH]: 1,
  [ELicensePeriod.YEAR]: 12,
};

const DEFAULT_COEFFICIENT = 1;

enum ETariffViewType {
  BILLING_DEPARTMENT_ACCOUNT = 'BILLING_DEPARTMENT_ACCOUNT',
  SUPPORT = 'SUPPORT',
  MANAGER = 'MANAGER',
  CLIENT = 'CLIENT',
}

export type TLicenseInfo = {
  period: ELicensePeriod;
  licensePrice: string | number;
  connectionFee: string | number;
  amauPrice: string | number;
  mauCount?: string | number | null;
  packagePrice: string | number;
  currency: string | null;
};

export {DETAIL_PERIOD_MONTHS, DEFAULT_COEFFICIENT, ETariffViewType};
export type {
  TAvailableTariff,
  TAvailableTariffResponse,
  TConnectedTariff,
  TConnectedTariffResponse,
  TTariffsLicensesFilters,
  TCreateAvailableTariffFormData,
  TTariffDetailFinalPrice,
};
